
export interface EvalData {
    title: string;
    description?: string;
    paper?: string;
    citation?: string;
    options?: EvalDataOptions;
    metrics: ObjectDef[];
    taskGroups: TaskGroupDef[];
    tasks: TaskDef[];
    models: ModelDef[];
    results: ModelResults[];
    filters?: FilterDef[];
    questions: Question[];
}

export interface Question {
    id: string;
    question: string;
    category: string;
    subcategory: string;
    expect: any;
    params?: any;
}

export interface ObjectDef {
    id: string;
    name?: string;
    description?: string;
    url?: string;
}

export interface EvalDataOptions {
    closeable?: boolean;
    expandable?: boolean;
    showHelp?: boolean;
    showFooter?: boolean;
    average?: boolean;
    tasksWon?: boolean;
}

export interface TaskDef extends ObjectDef {
    groupId?: string;
    precision?: number;
}

export interface TaskGroupDef extends ObjectDef {
    expanded?: boolean;
}

export interface ModelDef extends ObjectDef {
    warning?: string;
    tags?: string[];
    badge?: string;
    columns?: {[key: string]: any};
}

export interface FilterDef {
    name: string;
    options: FilterOption[];
}

export interface FilterOption {
    id: string;
    name: string;
    tag: string;
}

export interface ModelResults extends ModelDef {
    results: any;
    timestamp: string;
}

export enum CellType {
    EMPTY = "EMPTY",
    HEADER_GROUP = "HEADER_GROUP",
    SORTABLE_HEADER = "SORTABLE_HEADER",
    EXTRA_HEADER = "EXTRA_HEADER",
    HEADER = "HEADER",
    VALUE = "VALUE",
    ROWID = "ROWID",
    ROWID_HEADER = "ROWID_HEADER"
}

export interface Cell {
    value: string;
    type: CellType;
    colspan?: number;
    classes?: string;
    columnId?: string;
    url?: string;
    description?: string;
    warning?: string;
    rowid?: string;
    badge?: string;
}

export class Cells {

    public static empty(classes: string=""): Cell {
        return {value: "", type: CellType.EMPTY, classes: classes};
    }
}

export interface Changelog {
    model: string;
    updated: string;
    timestamp: Date;
}